<template>
	<div class="i-admin-tools">
		<btn l='ADMIN' i='cog' @press="shown=!shown"/>
		<div class="dialog" v-if="shown">
			<tabs>
				<tab title="Авторизация">
					<inputi v-model="form.login"/>
				</tab>
				<tab title="Пользователи">
					
				</tab>
			</tabs>
			<btn l='REQ' i='space-shuttle' @press="req"/>
			<div class="log">
				{{res}}
			</div>
		</div>
	</div>
</template>

<script>
import gql from 'graphql-tag'
export default {

  name: 'i-admin-tools',
  methods:{
  	async req(){
  		let res = await this.$gql.set( gql`mutation {
		  AdminAuthUser(login: "${this.form.login}") 
		}`)
		this.res = (res)
  	}
  },
  data () {
    return {
    	shown:false,
    	form: {},
    	res:{}
    }
  }
}
</script>

<style lang="css" scoped>
.i-admin-tools{
	position: fixed;
	z-index: 999999;
	top:0;
	left:0;
}
.dialog{
	border-radius: 4px;
	border:1px solid lightgrey;
	background: white;
}

.log{
	white-space: pre;
}
</style>